<script>
import bgImage1 from '@/assets/images/dashboard-bg2.jpg';
import bgImage2 from '@/assets/images/dashboard-bg1.jpg';

export default {
  data() {
    return {
      bgImages: [bgImage1, bgImage2],
      bgImage: null,
      intervalId: null,
    };
  },
  created() {
    this.changeBackground(); // Establece una imagen inicial
    this.startBackgroundRotation();
  },
  methods: {
    changeBackground() {
      const randomIndex = Math.floor(Math.random() * this.bgImages.length);
      this.bgImage = this.bgImages[randomIndex];
    },
    startBackgroundRotation() {
      this.intervalId = setInterval(this.changeBackground, 5000);
    },
  },
  beforeUnmount() {
    clearInterval(this.intervalId); // Limpia el intervalo cuando se destruye el componente
  },
};
</script>

<style scoped>
.hero.is-gray {
  background-color: #222222;
  color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  transition: background-image 1s ease-in-out;
}
</style>

<template>
  <section
    class="hero is-gray is-fullheight-with-navbar"
    :style="{ backgroundImage: 'url(' + bgImage + ')' }"
  >
    <div class="hero-body">
      <div class="container has-text-centered">
        <h1 class="title">¡Bienvenido a tu Panel de Administración!</h1>
        <h2 class="subtitle">
          Administra fácilmente socios, invitados, catálogos, interacciones y más.
        </h2>
      </div>
    </div>
  </section>
</template>
